export const deviceTypes = {
  MobileWebsite: 1,
  MobileApp: 2,
  BiometricDevice: 3
}

export default deviceTypes
